/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import classNames from 'classnames';
import intl from 'react-intl-universal';

export default function ActionsBarPres({
  percentProgress,
  isNextDisabled,
  isSubmitDisabled,
  isDraftVisible,
  isDraftDisabled,
  isFirstPage,
  isLastPage,
  onNextPage,
  onPrevPage,
  onCancel,
  onSubmit,
  onSaveDraft,
  isSubmitting,
}) {
  //currentProgress is dependent upon isSubmitDisabled,
  //if Submit is enabled user should be shown 100% progress.
  // Percent Progress is percentage of SI creation completed,
  // but in case last page is not having any elements,
  //then it should be shown 100% progress.
  const currentProgress = !isSubmitDisabled ? 100 : percentProgress;
  const progressClass = classNames({
    filled: true,
    'filled-complete': currentProgress === 100,
  });
  return (
    <section className="ssi-actions">
      <div className="ssi-button-wrapper">
        <div className="ssi-wrapper-cancelsave">
          <Button styleType="secondary" onClick={onCancel} className="action-button">
            {intl.get('serviceInit.addInit.actionBar.cancel')}
          </Button>
          {isDraftVisible && (
            <Button styleType="secondary" disabled={isDraftDisabled} onClick={onSaveDraft} className="action-button">
              {intl.get('serviceInit.addInit.actionBar.saveDraft')}
            </Button>
          )}
        </div>
        <hr className="vertical-divider" />
        <div className="ssi-wrapper-nextprevious">
          <Button styleType="secondary" disabled={isFirstPage} onClick={onPrevPage} className="action-button prev-button">
            &lt;
          </Button>
          <Button styleType="primary" disabled={isSubmitDisabled} onClick={onSubmit} className="action-button" isLoading={!isSubmitting}>
            {intl.get('serviceInit.addInit.actionBar.submit')}
          </Button>
          <Button styleType="secondary" disabled={isLastPage || isNextDisabled} onClick={onNextPage} className="action-button next-button">
            &gt;
          </Button>
        </div>
      </div>
      <div className="ssi-progress-wrapper">
        <span className="progress-text">
          {currentProgress}
          {intl.get('questionnaire.constants.percentageComplete')}
        </span>
        <div className="progress-bar">
          <span className={progressClass} style={{ width: `${currentProgress}%` }} />
        </div>
      </div>
    </section>
  );
}

ActionsBarPres.propTypes = {
  percentProgress: PropTypes.number,
  isNextDisabled: PropTypes.bool.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
  isDraftDisabled: PropTypes.bool.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  onNextPage: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSaveDraft: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/features/ServiceInit/presentational/ActionsBarPres.js